import { Component, Prop, h, Host } from '@stencil/core';

@Component({
  tag: 'dda-team-member-card',
  styleUrls: ['dda-team-member-card.css'],
  shadow: false,
})
export class DdaTeamMemberCard {
  @Prop() image_src: string;
  @Prop() image_alt: string;
  @Prop() team_member_name: string;
  @Prop() team_member_position: string;
  @Prop() design: string;
  @Prop() custom_class?: string = ''; 
  @Prop() component_mode?: string; 

  render() {
    const cardClass = [
      'dda-team-member-card dda-card',
      this.design ? `dda-team-member-card-${this.design}` : '',
      this.custom_class ? `${this.custom_class}` : "",
      this.component_mode,
    ].filter(Boolean).join(' ');

    return (
      <Host>
        <div class={cardClass}>
          <img class="dda-team-member-card-image" src={this.image_src} alt={this.image_alt}/>
          <div class="dda-text-center gap-xl ">
            <h5 class="h5 Regular">{this.team_member_name}</h5>
            <p class="body Regular dda-team-member-card-position">{this.team_member_position}</p>
            <slot></slot>
          </div>
        </div>
      </Host>
    );
  }
}
